import { consumptionAlertClient } from '@/lib/api/ts-rest';
import { saveDownload } from '@/lib/download';
import { useMutation } from '@tanstack/react-query';
import { useDefaultSite } from './useDefaultSite';
import type { UseExportConsumptionAlertsParams } from './useConsumptionAlerts';

/** Exports every alert matching the current filters, not just the page shown. */
export function useExportConsumptionAlerts({
  organizationId,
  q,
  from,
  to,
}: UseExportConsumptionAlertsParams) {
  const { currentSite } = useDefaultSite();

  return useMutation({
    mutationFn: async ({
      format,
      delimiter = ';',
    }: {
      format: 'xlsx' | 'csv';
      delimiter?: string;
    }) => {
      if (!organizationId) throw new Error('No organization selected');
      const body = { q: q?.trim() || undefined, from, to, format, delimiter };
      const res = currentSite
        ? await consumptionAlertClient.exportSiteAlerts({
            params: { organizationId, siteId: currentSite.id },
            body,
          })
        : await consumptionAlertClient.exportAlerts({
            params: { organizationId },
            body,
          });
      if (res.status !== 200) throw new Error('Export failed');
      saveDownload(
        res.body,
        `eiko-export-alertes-consommation-${new Date().toISOString()}.${format}`,
      );
    },
  });
}
